import { type Drawer, Printer } from "escpos-buffer";

export const fakePrinterEnabled = (): boolean =>
  !!localStorage.getItem("fakePrinter.enabled");
export const fakePrinterAuthorised = (): boolean =>
  !!localStorage.getItem("fakePrinter.authorised");
export const setFakePrinterAuthorised = () =>
  localStorage.setItem("fakePrinter.authorised", "true");

export function authoriseFakePrinter() {
  if (!fakePrinterAuthorised()) {
    if (!confirm("Authorise FakePrinter?")) {
      throw new Error("No FakePrinter Chosen");
    }
    setFakePrinterAuthorised();
  }
}

export class FakePrinter extends Printer {
  private async delay(n = 1): Promise<void> {
    return new Promise((resolve) => setTimeout(() => resolve(null), n));
  }

  lines = [];

  get columns() {
    return 50;
  }

  async writeln(text, ...args) {
    this.lines.push([`${text}\n`, ...args]);
    return this.delay();
  }

  async write(...args) {
    this.lines.push(args);
    return this.delay();
  }

  async draw(image) {
    this.lines.push([image]);
    return this.delay();
  }

  async feed(lines) {
    this.lines.push(...Array(lines).fill(["\n"]));
    return this.delay();
  }

  async setCodepage(_value: string) {
    return this.delay();
  }

  async drawer(_number?: Drawer, _onTime?: number, _offTime?: number) {
    return this.delay();
  }

  async qrcode(_data: string, _size?: number) {
    this.lines.push(["<< QR Code >>\n"]);
    return this.delay();
  }

  async buzzer() {
    this.lines.push(["-----BUZZ-----"]);
    return this.delay();
  }

  async cutter() {
    this.lines.push(["-----CUT-----"]);

    console.log(this.lines);
    await this.delay(500);
    this.lines = [];
  }

  async close() {
    this.lines = [];
    return this.delay();
  }

  async setAlignment() {
    return this.delay();
  }
}
